import { render } from "./EventCard.vue?vue&type=template&id=8c6c028e&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=8c6c028e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c6c028e"

export default script